import { debounce } from "lodash";

export const containerStyle = { width: "100vw", height: "calc(var(--vh, 1vh) * 100)" };
export const dragDebounced = debounce((setSnap) => setSnap(false), 150);
export const center = { lat: 37.0902, lng: -95.7129 };
export const bounds = { north: 60, south: 15, east: -60, west: -135 };
export const MIN_ZOOM_LEVEL = 4;
export const DATA_CHUNK_SIZE = 0;
